import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
function contextEnhance(context, setOnProp) {
  return function (props) {
    var other = _extends({}, (_objectDestructuringEmpty(props), props));
    var value = React.useContext(context);
    return _objectSpread(_objectSpread({}, other), {}, _defineProperty({}, setOnProp, value));
  };
}
export default contextEnhance;
//# sourceMappingURL=contextEnhance.mjs.map